/* eslint-disable prefer-template */
/* eslint-disable multiline-ternary */
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Card,
  CardBody,
  Col,
  Label,
  Form,
  Row,
  FormFeedback,
} from "reactstrap";
import {
  orderProjectData,
  priceForUser,
  renderValueBasedOnRange,
  // renderValueBasedOnRangeDiff,
} from "./utils";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createStripeCustomer } from "../../../../services/subscription.service";
import { subscriptionDetails } from "../../../../redux/subscription";
import PaymentWizard from "../../../../common/PaymentModal/PaymentWizard";
import ToastContent from "../../../components/toast/toast";
import toast from "react-hot-toast";
import { Check, X } from "react-feather";
import StripeElement from "../../../../common/stripeComponent/StripeElement";
import { getErrorMsg } from "../../../../common/ErrorMessages/errorMessage";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "animate.css/animate.css";
import "@styles/base/plugins/extensions/ext-component-sweet-alerts.scss";

import { USER_ROUTES } from "../../../../constant/route";
import { useNavigate } from "react-router-dom";
import { numberWithCommas } from "../../../../common/functions/helperFunctions";
import CPtoClipBoardModal from "../../../components/modals/CPtoClipboard";

const MySwal = withReactContent(Swal);

const schema = yup.object().shape({});

const PricingCalculatorModel = (props) => {
  const { show, setShow } = props;

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser);

  // ** State

  const [open, setOpen] = useState("1");

  const [suggestedPlan, setSuggestedPlan] = useState();
  const [paymentPopup, setPaymentPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [CopyModal, setCopyModal] = useState({ isOpen: false, data: "" });

  const userPlanType = 1;

  const defaultValues = {
    footage_size: "",
    event_last_day: "",
    insta_video: false,
    insta_video_qty: "",
    highlight_video: {
      min_2_3: false,
      min_2_3_qty: "",
      min_4_6: false,
      min_4_6_qty: "",
    },
    narrative_highlight_video: {
      min_3_5: false,
      min_3_5_qty: "",
      min_6_8: false,
      min_6_8_qty: "",
      min_9_12: false,
      min_9_12_qty: "",
    },
    cinematic_film: {
      min_13_15: false,
      min_13_15_qty: "",
      min_16_20: false,
      min_16_20_qty: "",
      min_21_25: false,
      min_21_25_qty: "",
    },
    documentary_edits: {
      ceremony_MCE: false,
      ceremony_MCE_qty: "",
      reception_MCE: false,
      reception_MCE_qty: "",
      dances_only: false,
      dances_only_qty: "",
      speeches_only: false,
      speeches_only_qty: "",
      ceremony_reception_MCE: false,
      ceremony_reception_MCE_qty: "",
    },
    discount_code: "",
  };

  const {
    setError,
    watch,
    reset,
    clearErrors,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues, resolver: yupResolver(schema) });
  console.error("errors: ", errors);

  useEffect(() => {
    if (show) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "visible";
  }, [show]);

  const QtyInput = (name, isChecked) => (
    <>
      {/* <Controller
        name={name}
        control={control}
        rules={{ required: true, min: 1 }}
        render={({ field }) => (
          <Input {...field} type="number" placeholder="Qty" />
        )}
      /> */}

      <Controller
        name={name}
        control={control}
        rules={{
          required: true,
          pattern: /^[0-9]*$/,
        }}
        render={({ field, fieldState: { error } }) => (
          <>
            <Input
              disabled={!isChecked}
              // disabled
              {...field}
              type="text"
              maxLength={3}
              placeholder="Qty"
              onKeyDown={(event) => {
                const allowedKeys = [
                  "Backspace",
                  "Delete",
                  "ArrowLeft",
                  "ArrowRight",
                  "Ctrl",
                  // "Shift",
                ];
                if (
                  !/^[0-9]$/.test(event.key) && // ? Check if the pressed key is a digit from 0 to 9
                  !allowedKeys.includes(event.key) // ? Check if the pressed key is the Backspace or Delete key
                ) {
                  event.preventDefault(); // ? Prevent entering non-allowed characters
                }
              }}
              onChange={(event) => {
                field.onChange(event);
                const value = event.target.value;

                if (value === "" || value === "0") {
                  // field.onChange(1);
                  // ? change value to 1
                  // field.onChange(""); // Clear the input field value
                  setError(name, {
                    type: "manual",
                    message: "Quantity is Required",
                  });
                } else {
                  clearErrors(name); // ?  Clear any previous error for this field
                }
                // field.onBlur(); // ?  Trigger the default onBlur event
              }}
            />
            {error && (
              <FormFeedback className="error-message">
                {error.message}
              </FormFeedback>
            )}
          </>
        )}
      />
    </>
  );

  const selectedCheckboxes = watch();
  // orderProjectData?.map((row) => row.fieldName)

  const calculateTotalAmount = () => {
    let totalAmount = 0;
    // if (checkUserPlanType(userPlanType) === USER_PLAN_TYPE.SUBSCRIBER) {
    orderProjectData.forEach((checkbox) => {
      let newValue;
      if (checkbox.fieldName.endsWith("]")) {
        const closingBracketIndex = checkbox.fieldName.indexOf("]");
        newValue =
          checkbox.fieldName.substring(0, closingBracketIndex) +
          "_qty" +
          checkbox.fieldName.substring(closingBracketIndex);
      } else {
        newValue = checkbox.fieldName + "_qty";
      }
      const qty = watch(newValue);
      // if (watch(checkbox.fieldName) && watch(checkbox.fieldName) !== "1") {
      const qtyno = parseInt(qty);
      //   console.log(
      //     "totalAmount---->>> total up",
      //     parseInt(checkbox.forSubscriber.match(/\d+/)[0]),
      //     qtyno,
      //     totalAmount,
      //     typeof qtyno === "number" && !isNaN(qtyno)
      //   );
      //   if (typeof qtyno === "number" && !isNaN(qtyno)) {
      //     // const qtyTotal =
      //     //   parseInt(checkbox.forSubscriber.match(/\d+/)[0]) * qty;
      //     console.log("totalAmount---->>> total qtyTotal", qtyno, totalAmount);
      //     // totalAmount = qtyTotal;
      //     totalAmount += parseInt(checkbox.forSubscriber.match(/\d+/)[0]) * qty;
      //   } else {
      //     totalAmount += parseInt(checkbox.forSubscriber.match(/\d+/)[0]);
      //   }
      //   console.log("totalAmount---->>> total down", totalAmount);
      // }
      if (watch(checkbox.fieldName)) {
        if (typeof qtyno === "number" && !isNaN(qtyno)) {
          totalAmount +=
            parseInt(checkbox.forSubscriber.match(/\d+/)[0]) * qtyno;
        }
        // else {
        //   totalAmount += parseInt(checkbox.forSubscriber.match(/\d+/)[0]);
        // }
      }
    });

    // if (selectEventLastDay?.value) {
    //   const percentage = getEventDayPercentage(selectEventLastDay?.value);
    //   const discountTotal = (totalAmount * percentage) / 100;

    //   totalAmount = totalAmount + discountTotal;
    // }

    return totalAmount;
    // }
    // else {
    //   orderProjectData.forEach((checkbox) => {
    //     const qty = watch(`${checkbox.fieldName}_qty`);
    //     if (watch(checkbox.fieldName)) {
    //       totalAmount +=
    //         parseInt(checkbox.forAlacarte.match(/\d+/)[0]) * parseInt(qty || 0);
    //     }
    //   });

    //   // if (selectEventLastDay?.value) {
    //   //   const percentage = getEventDayPercentage(selectEventLastDay?.value);
    //   //   const discountTotal = (totalAmount * percentage) / 100;
    //   //   totalAmount = totalAmount + discountTotal;
    //   // }

    //   return totalAmount;
    // }
  };
  // const subscriptionData = useSelector((state) => state.subscription);

  function getSubscriptionPlan(value, plansArray) {
    for (let i = 0; i < plansArray.length; i++) {
      const plan = plansArray[i];
      if (value >= plan.min && value <= plan.max) {
        return plan;
      }
    }
    // **  return null or throw an error if no plan is found for the given value
    return null;
  }

  const plans = [
    { id: 1, value: "Quartz", min: 480, max: 719 },
    { id: 2, value: "Amber", min: 720, max: 1199 },
    { id: 3, value: "Sapphire", min: 1200, max: 2159 },
    { id: 4, value: "Emerald", min: 2160, max: 4319 },
    { id: 5, value: "Ruby", min: 4320, max: 7199 },
    { id: 6, value: "Diamond", min: 7200, max: Infinity },
  ];

  function renderPlanBasedOnValue() {
    const plan = getSubscriptionPlan(calculateTotalAmount(), plans);
    setSuggestedPlan(plan?.id);
  }

  useEffect(() => {
    calculateTotalAmount();
    renderPlanBasedOnValue();
  }, [selectedCheckboxes]);

  const onSubmit = async () => {
    setIsLoading(true);
    const value = {
      subscription_id: suggestedPlan,
    };
    try {
      const res = await createStripeCustomer(
        value,
        currentUser?.currentuserdata?.data?.user_subscription_id
      );

      // ** IF No payment method Found
      if (res?.data?.payment_method === "no_payment_method") {
        const payload = {
          planId: suggestedPlan,
          client_secret: res?.data?.client_secret,
        };
        dispatch(subscriptionDetails(payload));
        setPaymentPopup(true);
        toast((t) => (
          <ToastContent
            t={t.id}
            message={res?.message}
            icon={<Check size={12} />}
          />
        ));
        setIsLoading(false);
        // setShow(false);
      } else {
        toast((t) => (
          <ToastContent
            t={t.id}
            message={res?.message}
            icon={<Check size={12} />}
          />
        ));

        setIsLoading(false);
        setShow(false);
        navigate(USER_ROUTES.MY_PROJECTS);
        MySwal.fire({
          title: "Subscription Purchased Successfully",
          // text: "You clicked the button!",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    } catch (err) {
      console.log("err: ", err);
      // ** If redirect Link Found
      // if (err.response?.data?.data?.redirect_to) {
      //   window.open(err.response?.data?.data?.redirect_to);
      // }
      if (err.response?.data?.data?.redirect_to) {
        const win = window.open(
          err.response?.data?.data?.redirect_to
          // "_blank"
        );
        if (win === null || typeof win === "undefined") {
          setCopyModal({
            isOpen: true,
            data: err.response?.data?.data,
          });
          if (module === "subscription") {
            setConfSubscription({ open: false, value: "" });
          }
          setShow(false);
          setIsLoading(false);

          // Popup blocked, display message in UI
          toast((t) => (
            <ToastContent
              t={t.id}
              message="Popup blocked. Please enable popups and try again."
              color="danger"
              icon={<X size={12} />}
            />
          ));
        }
      }
      setIsLoading(false);
      getErrorMsg(err);
      // toast((t) => (
      //   <ToastContent
      //     t={t.id}
      //     message={err.response?.data?.message}
      //     color="danger"
      //     icon={<X size={12} />}
      //   />
      // ));
    }
  };

  const toggle = (id) => {
    open === id ? setOpen() : setOpen(id);
  };
  return (
    <>
      {" "}
      <Modal
        isOpen={show}
        toggle={() => {
          setShow(!show);
          reset();
        }}
        className="modal-dialog-centered modal-xl "
        backdrop="static"
      >
        <ModalHeader
          className="bg-transparent"
          toggle={() => {
            setShow(!show);
            reset();
          }}
        ></ModalHeader>
        <ModalBody className="px-sm-5 mx-50 pb-5 pricing-calc text-capitalize">
          <h1 className="text-center mb-1">
            Let's Choose The Right Plan For You.
          </h1>
          <p className="text-center mb-3" style={{ textTransform: "initial" }}>
            {/* TELL US ABOUT YOUR REQUIREMENT ANNUALLY */}
            {/* Tell Us About Your Requirement Annually */}
            Please select the total amount of each type of edit you anticipate
            needing in the next 12 months
          </p>

          <Row>
            <Col xs={12} xl={8}>
              <Accordion
                className="accordion-margin"
                open={open}
                toggle={toggle}

                // stayOPen
                // stayOpen
                // defaultOpen={["1"]}
              >
                {/* 1 */}
                <AccordionItem>
                  <AccordionHeader targetId="1">
                    Instagram Video
                  </AccordionHeader>
                  <AccordionBody accordionId="1">
                    <div className="order-accordian">
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            name="insta_video"
                            control={control}
                            render={({ field }) => (
                              <>
                                <Input
                                  type="checkbox"
                                  id="instavideo"
                                  {...field}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    if (
                                      e.target.checked &&
                                      !watch("insta_video_qty")
                                    ) {
                                      setError("insta_video_qty", {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      });
                                    } else {
                                      clearErrors("insta_video_qty");
                                    }
                                  }}
                                />
                                <Label
                                  for="instavideo"
                                  className="form-check-label ms-1"
                                >
                                  1 Minute
                                </Label>
                              </>
                            )}
                          />
                          <div className="ms-1">
                            {priceForUser(userPlanType, "insta_video")}
                          </div>
                          {QtyInput("insta_video_qty", watch("insta_video"))}
                        </div>
                      </div>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                {/* 2 */}
                <AccordionItem>
                  <AccordionHeader targetId="2">
                    Music Highlight Video – Music Only
                  </AccordionHeader>
                  <AccordionBody accordionId="2">
                    <div className="order-accordian">
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            name="highlight_video[min_2_3]"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <>
                                <Input
                                  type="checkbox"
                                  id="highlight_min_2_3"
                                  {...field}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    if (
                                      e.target.checked &&
                                      !watch("highlight_video[min_2_3_qty]")
                                    ) {
                                      setError("highlight_video[min_2_3_qty]", {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      });
                                    } else {
                                      clearErrors(
                                        "highlight_video[min_2_3_qty]"
                                      );
                                    }
                                  }}
                                />
                                <Label
                                  for="highlight_min_2_3"
                                  className="form-check-label ms-1"
                                >
                                  2-3 minutes
                                </Label>
                              </>
                            )}
                          />
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "highlight_video[min_2_3]"
                            )}
                          </div>
                          {QtyInput(
                            "highlight_video[min_2_3_qty]",
                            watch("highlight_video[min_2_3]")
                          )}

                          {/* {QtyInput("highlight_video[min_2_3_qty]"  )} */}
                          {/* <QtyInputCom
                              name="highlight_video[min_2_3_qty]"
                              isChecked={watch("highlight_video[min_2_3]")} // Pass the checkbox value to isChecked prop
                            /> */}
                        </div>
                      </div>
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            name="highlight_video[min_4_6]"
                            control={control}
                            defaultValue=""
                            rules={{ required: true }}
                            render={({ field }) => (
                              <>
                                <Input
                                  type="checkbox"
                                  id="highlight_min_4_6"
                                  {...field}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    if (
                                      e.target.checked &&
                                      !watch("highlight_video[min_4_6_qty]")
                                    ) {
                                      setError("highlight_video[min_4_6_qty]", {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      });
                                    } else {
                                      clearErrors(
                                        "highlight_video[min_4_6_qty]"
                                      );
                                    }
                                  }}
                                />
                                <Label
                                  for="highlight_min_4_6"
                                  className="form-check-label ms-1"
                                >
                                  4-6 minutes
                                </Label>
                              </>
                            )}
                          />
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "highlight_video[min_4_6]"
                            )}
                          </div>

                          {/* {QtyInput("highlight_video[min_4_6_qty]")} */}

                          {QtyInput(
                            "highlight_video[min_4_6_qty]",
                            watch("highlight_video[min_4_6]")
                          )}
                        </div>
                      </div>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                {/* 3 */}
                <AccordionItem>
                  <AccordionHeader targetId="3">
                    Narrative Highlight Video – Music + Dialogue
                  </AccordionHeader>
                  <AccordionBody accordionId="3">
                    <div className="order-accordian">
                      <div className="order-info mb-1 mb-md-0">
                        <Controller
                          name="narrative_highlight_video[min_3_5]"
                          control={control}
                          defaultValue={false}
                          render={({ field }) => (
                            <div className="form-check form-check-inline">
                              <Input
                                type="checkbox"
                                id="narrative_highlight_video_min_3_5"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch(
                                      "narrative_highlight_video[min_3_5_qty]"
                                    )
                                  ) {
                                    setError(
                                      "narrative_highlight_video[min_3_5_qty]",
                                      {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      }
                                    );
                                  } else {
                                    clearErrors(
                                      "narrative_highlight_video[min_3_5_qty]"
                                    );
                                  }
                                }}
                              />
                              <Label
                                for="narrative_highlight_video_min_3_5"
                                className="form-check-label ms-1"
                              >
                                3-5 minutes
                              </Label>
                              <div className="ms-1">
                                {priceForUser(
                                  userPlanType,
                                  "narrative_highlight_video[min_3_5]"
                                )}
                              </div>
                              {/* {QtyInput(
                                  "narrative_highlight_video[min_3_5_qty]"
                                )} */}
                              {QtyInput(
                                "narrative_highlight_video[min_3_5_qty]",
                                watch("narrative_highlight_video[min_3_5]")
                              )}
                            </div>
                          )}
                        />
                        {/* </div> */}
                      </div>
                      <div className="order-info mb-1 mb-md-0">
                        <Controller
                          name="narrative_highlight_video[min_6_8]"
                          control={control}
                          render={({ field }) => (
                            <div className="form-check form-check-inline">
                              <Input
                                type="checkbox"
                                id="narrative_highlight_video_min_6_8"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch(
                                      "narrative_highlight_video[min_6_8_qty]"
                                    )
                                  ) {
                                    setError(
                                      "narrative_highlight_video[min_6_8_qty]",
                                      {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      }
                                    );
                                  } else {
                                    clearErrors(
                                      "narrative_highlight_video[min_6_8_qty]"
                                    );
                                  }
                                }}
                              />
                              <Label
                                for="narrative_highlight_video_min_6_8"
                                className="form-check-label ms-1"
                              >
                                6-8 minutes
                              </Label>
                              <div className="ms-1">
                                {priceForUser(
                                  userPlanType,
                                  "narrative_highlight_video[min_6_8]"
                                )}
                              </div>

                              {/* {QtyInput(
                                  "narrative_highlight_video[min_6_8_qty]"
                                )} */}

                              {QtyInput(
                                "narrative_highlight_video[min_6_8_qty]",
                                watch("narrative_highlight_video[min_6_8]")
                              )}
                            </div>
                          )}
                        />
                      </div>
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="narrative_highlight_video[min_9_12]"
                            defaultValue={false}
                            render={({ field }) => (
                              <Input
                                type="checkbox"
                                id="narrative_highlight_video_min_9_12"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch(
                                      "narrative_highlight_video[min_9_12_qty]"
                                    )
                                  ) {
                                    setError(
                                      "narrative_highlight_video[min_9_12_qty]",
                                      {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      }
                                    );
                                  } else {
                                    clearErrors(
                                      "narrative_highlight_video[min_9_12_qty]"
                                    );
                                  }
                                }}
                              />
                            )}
                          />
                          <Label
                            for="narrative_highlight_video_min_9_12"
                            className="form-check-label ms-1"
                          >
                            9-12 minutes
                          </Label>
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "narrative_highlight_video[min_9_12]"
                            )}
                          </div>
                          {/* {QtyInput(
                              "narrative_highlight_video[min_9_12_qty]"
                            )} */}

                          {QtyInput(
                            "narrative_highlight_video[min_9_12_qty]",
                            watch("narrative_highlight_video[min_9_12]")
                          )}
                        </div>
                      </div>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                {/* 4 */}
                <AccordionItem>
                  <AccordionHeader targetId="4">
                    Cinematic Feature Film – Music + Dialogue
                  </AccordionHeader>
                  <AccordionBody accordionId="4">
                    <div className="order-accordian">
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="cinematic_film[min_13_15]"
                            render={({ field }) => (
                              <>
                                <Input
                                  type="checkbox"
                                  id="cinematic_film_min_13_15"
                                  {...field}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    if (
                                      e.target.checked &&
                                      !watch("cinematic_film[min_13_15_qty]")
                                    ) {
                                      setError(
                                        "cinematic_film[min_13_15_qty]",
                                        {
                                          type: "manual",
                                          message: "Quantity is Required",
                                        }
                                      );
                                    } else {
                                      clearErrors(
                                        "cinematic_film[min_13_15_qty]"
                                      );
                                    }
                                  }}
                                />
                                <Label
                                  for="cinematic_film_min_13_15"
                                  className="form-check-label ms-1"
                                >
                                  13-15 minutes
                                </Label>
                                <div className="ms-1">
                                  {priceForUser(
                                    userPlanType,
                                    "cinematic_film[min_13_15]"
                                  )}
                                </div>
                                {/* {QtyInput("cinematic_film[min_13_15_qty]")} */}

                                {QtyInput(
                                  "cinematic_film[min_13_15_qty]",
                                  watch("cinematic_film[min_13_15]")
                                )}
                              </>
                            )}
                          />
                        </div>
                      </div>
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="cinematic_film[min_16_20]"
                            defaultValue={false}
                            render={({ field }) => (
                              <Input
                                type="checkbox"
                                id="cinematic_film_min_16_20"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch("cinematic_film[min_16_20_qty]")
                                  ) {
                                    setError("cinematic_film[min_16_20_qty]", {
                                      type: "manual",
                                      message: "Quantity is Required",
                                    });
                                  } else {
                                    clearErrors(
                                      "cinematic_film[min_16_20_qty]"
                                    );
                                  }
                                }}
                              />
                            )}
                          />
                          <Label
                            for="cinematic_film_min_16_20"
                            className="form-check-label ms-1"
                          >
                            16-20 minutes
                          </Label>
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "cinematic_film[min_16_20]"
                            )}
                          </div>
                          {/* {QtyInput("cinematic_film[min_16_20_qty]")} */}

                          {QtyInput(
                            "cinematic_film[min_16_20_qty]",
                            watch("cinematic_film[min_16_20]")
                          )}
                        </div>
                      </div>

                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="cinematic_film[min_21_25]"
                            defaultValue={false}
                            render={({ field }) => (
                              <Input
                                type="checkbox"
                                id="cinematic_film_min_21_25"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch("cinematic_film[min_21_25_qty]")
                                  ) {
                                    setError("cinematic_film[min_21_25_qty]", {
                                      type: "manual",
                                      message: "Quantity is Required",
                                    });
                                  } else {
                                    clearErrors(
                                      "cinematic_film[min_21_25_qty]"
                                    );
                                  }
                                }}
                              />
                            )}
                          />
                          <Label
                            for="cinematic_film_min_21_25"
                            className="form-check-label ms-1"
                          >
                            21-25 minutes
                          </Label>
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "cinematic_film[min_21_25]"
                            )}
                          </div>
                          {/* {QtyInput("cinematic_film[min_21_25_qty]")} */}

                          {QtyInput(
                            "cinematic_film[min_21_25_qty]",
                            watch("cinematic_film[min_21_25]")
                          )}
                        </div>
                      </div>
                    </div>
                  </AccordionBody>
                </AccordionItem>

                {/* 5 */}
                <AccordionItem>
                  <AccordionHeader targetId="5">
                    Documentary Edits
                  </AccordionHeader>
                  <AccordionBody accordionId="5">
                    <div className="order-accordian">
                      {/* 1 point */}
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="documentary_edits[ceremony_MCE]"
                            defaultValue={false}
                            render={({ field }) => (
                              <Input
                                type="checkbox"
                                id="documentary_edits_ceremony_MCE"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch(
                                      "documentary_edits[ceremony_MCE_qty]"
                                    )
                                  ) {
                                    setError(
                                      "documentary_edits[ceremony_MCE_qty]",
                                      {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      }
                                    );
                                  } else {
                                    clearErrors(
                                      "documentary_edits[ceremony_MCE_qty]"
                                    );
                                  }
                                }}
                              />
                            )}
                          />
                          <Label
                            for="documentary_edits_ceremony_MCE"
                            className="form-check-label ms-1"
                          >
                            Ceremony Edit
                          </Label>
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "documentary_edits[ceremony_MCE]"
                            )}
                          </div>
                          {/* {QtyInput("documentary_edits[ceremony_MCE_qty]")} */}

                          {QtyInput(
                            "documentary_edits[ceremony_MCE_qty]",
                            watch("documentary_edits[ceremony_MCE]")
                          )}
                        </div>
                      </div>

                      {/* 2 point */}
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="documentary_edits[reception_MCE]"
                            defaultValue={false}
                            render={({ field }) => (
                              <Input
                                type="checkbox"
                                id="documentary_edits_reception_MCE"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch(
                                      "documentary_edits[reception_MCE_qty]"
                                    )
                                  ) {
                                    setError(
                                      "documentary_edits[reception_MCE_qty]",
                                      {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      }
                                    );
                                  } else {
                                    clearErrors(
                                      "documentary_edits[reception_MCE_qty]"
                                    );
                                  }
                                }}
                              />
                            )}
                          />
                          <Label
                            for="documentary_edits_reception_MCE"
                            className="form-check-label ms-1"
                          >
                            Reception Edit
                          </Label>
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "documentary_edits[reception_MCE]"
                            )}
                          </div>
                          {/* {QtyInput("documentary_edits[reception_MCE_qty]")} */}

                          {QtyInput(
                            "documentary_edits[reception_MCE_qty]",
                            watch("documentary_edits[reception_MCE]")
                          )}
                        </div>
                      </div>

                      {/* 3 point*/}
                      <div className="order-info mb-1 mb-md-0">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="documentary_edits[dances_only]"
                            defaultValue={false}
                            render={({ field }) => (
                              <Input
                                type="checkbox"
                                id="documentary_edits_dances_only"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch("documentary_edits[dances_only_qty]")
                                  ) {
                                    setError(
                                      "documentary_edits[dances_only_qty]",
                                      {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      }
                                    );
                                  } else {
                                    clearErrors(
                                      "documentary_edits[dances_only_qty]"
                                    );
                                  }
                                }}
                              />
                            )}
                          />
                          <Label
                            for="documentary_edits_dances_only"
                            className="form-check-label ms-1"
                          >
                            Dances Only
                          </Label>
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "documentary_edits[dances_only]"
                            )}
                          </div>
                          {/* {QtyInput("documentary_edits[dances_only_qty]")} */}

                          {QtyInput(
                            "documentary_edits[dances_only_qty]",
                            watch("documentary_edits[dances_only]")
                          )}
                        </div>
                      </div>
                      <hr />
                      {/* 4 point*/}
                      <div className="order-info mb-1 mb-md-0 mt-1">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="documentary_edits[speeches_only]"
                            defaultValue={false}
                            render={({ field }) => (
                              <Input
                                type="checkbox"
                                id="documentary_edits_speeches_only"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch(
                                      "documentary_edits[speeches_only_qty]"
                                    )
                                  ) {
                                    setError(
                                      "documentary_edits[speeches_only_qty]",
                                      {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      }
                                    );
                                  } else {
                                    clearErrors(
                                      "documentary_edits[speeches_only_qty]"
                                    );
                                  }
                                }}
                              />
                            )}
                          />
                          <Label
                            for="documentary_edits_speeches_only"
                            className="form-check-label ms-1"
                          >
                            Speeches Only
                          </Label>
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "documentary_edits[speeches_only]"
                            )}
                          </div>
                          {/* {QtyInput("documentary_edits[speeches_only_qty]")} */}

                          {QtyInput(
                            "documentary_edits[speeches_only_qty]",
                            watch("documentary_edits[speeches_only]")
                          )}
                        </div>
                      </div>

                      {/* 5 point*/}
                      <div className="order-info mb-1 mb-md-0 mt-1">
                        <div className="form-check form-check-inline">
                          <Controller
                            control={control}
                            name="documentary_edits[ceremony_reception_MCE]"
                            defaultValue={false}
                            render={({ field }) => (
                              <Input
                                type="checkbox"
                                id="documentary_edits_ceremony_reception_MCE"
                                {...field}
                                onChange={(e) => {
                                  field.onChange(e);
                                  if (
                                    e.target.checked &&
                                    !watch(
                                      "documentary_edits[ceremony_reception_MCE_qty]"
                                    )
                                  ) {
                                    setError(
                                      "documentary_edits[ceremony_reception_MCE_qty]",
                                      {
                                        type: "manual",
                                        message: "Quantity is Required",
                                      }
                                    );
                                  } else {
                                    clearErrors(
                                      "documentary_edits[ceremony_reception_MCE_qty]"
                                    );
                                  }
                                }}
                              />
                            )}
                          />
                          <Label
                            for="documentary_edits_ceremony_reception_MCE"
                            className="form-check-label ms-1"
                          >
                            Ceremony + Reception Edit
                          </Label>
                          <div className="ms-1">
                            {priceForUser(
                              userPlanType,
                              "documentary_edits[ceremony_reception_MCE]"
                            )}
                          </div>
                          {/* {QtyInput(
                              "documentary_edits[ceremony_reception_MCE_qty]"
                            )} */}

                          {QtyInput(
                            "documentary_edits[ceremony_reception_MCE_qty]",
                            watch("documentary_edits[ceremony_reception_MCE]")
                          )}
                        </div>
                      </div>
                    </div>
                  </AccordionBody>
                </AccordionItem>
              </Accordion>
              {/* </CardBody>
              </Card> */}
            </Col>
            <Col xs={12} xl={4} className="order-price-box mt-1 ">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <Card className="order-box">
                  <CardBody>
                    <div className="price-details">
                      <ul className="list-unstyled">
                        <li className="price-detail">
                          <div className="detail-title">
                            The best Plan for you would be :
                          </div>
                          <div className="order-amt discount-amt text-success">
                            {/* {(() => {
                              const val = calculateTotalAmount();
                              switch (true) {
                                case val >= 480 && val <= 700:
                                  return <>Quartz</>;
                                case val >= 720 && val <= 1199:
                                  return <>Amber</>;
                                case val >= 1200 && val <= 2159:
                                  return <>Sapphire</>;
                                case val >= 2160 && val <= 4319:
                                  return <>Emerald</>;
                                case val >= 4320 && val <= 7199:
                                  return <>Ruby</>;
                                case val >= 7200:
                                  return <>Diamond</>;
                                default:
                                  return <>A La carte</>;
                              }
                            })()} */}

                            {renderValueBasedOnRange(
                              calculateTotalAmount(),
                              [
                                {
                                  min: 1,
                                  max: 479,
                                  value: "A La Carte",
                                  id: 0,
                                },
                                { min: 480, max: 719, value: "Quartz", id: 1 },
                                { min: 720, max: 1199, value: "Amber", id: 2 },
                                {
                                  min: 1200,
                                  max: 2159,
                                  value: "Sapphire",
                                  id: 3,
                                },
                                {
                                  min: 2160,
                                  max: 4319,
                                  value: "Emerald",
                                  id: 4,
                                },
                                { min: 4320, max: 7199, value: "Ruby", id: 5 },
                                {
                                  min: 7200,
                                  max: Infinity,
                                  value: "Diamond",
                                  id: 6,
                                },
                              ],
                              "-"
                            )}
                          </div>
                        </li>
                        <li className="price-detail">
                          <div className="order-title">Total Carats :</div>

                          <div className="order-amt fw-bolder">
                            {numberWithCommas(calculateTotalAmount())}
                            {}
                          </div>
                        </li>

                        <li className="price-detail">
                          <div className="order-title">
                            Total Price for this plan :
                          </div>

                          <div className="order-amt fw-bolder">
                            {renderValueBasedOnRange(
                              calculateTotalAmount(),
                              [
                                {
                                  min: 1,
                                  max: 479,
                                  value: "-",
                                  id: 0,
                                },
                                {
                                  min: 480,
                                  max: 719,
                                  value: "$ 425/mo",
                                  id: 1,
                                },
                                {
                                  min: 720,
                                  max: 1199,
                                  value: "$ 800/mo",
                                  id: 2,
                                },
                                {
                                  min: 1200,
                                  max: 2159,
                                  value: "$ 1,125/mo",
                                  id: 3,
                                },
                                {
                                  min: 2160,
                                  max: 4319,
                                  value: "$ 2,100/mo",
                                  id: 4,
                                },
                                {
                                  min: 4320,
                                  max: 7199,
                                  value: "$ 3,900/mo",
                                  id: 5,
                                },
                                {
                                  min: 7200,
                                  max: Infinity,
                                  value: "$ 7,200/mo",
                                  id: 6,
                                },
                              ],
                              "-"
                            )}
                          </div>
                        </li>
                        <li className="price-detail">
                          <div className="detail-title">You will save :</div>
                          <div className="detail-amt discount-amt ">
                            {" "}
                            {/* {(() => {
                              const val = calculateTotalAmount();
                              switch (true) {
                                case val >= 480 && val <= 719:
                                  return <>15</>;
                                case val >= 720 && val <= 1199:
                                  return <>20</>;
                                case val >= 1200 && val <= 2159:
                                  return <>25</>;
                                case val >= 2160 && val <= 4319:
                                  return <>30</>;
                                case val >= 4320 && val <= 7199:
                                  return <>35</>;
                                case val >= 7200:
                                  return <>40</>;
                                default:
                                  return <>0</>;
                              }
                            })()}{" "} */}
                            {renderValueBasedOnRange(
                              calculateTotalAmount(),
                              [
                                { min: 480, max: 719, value: 15 },
                                { min: 720, max: 1199, value: 20 },
                                { min: 1200, max: 2159, value: 25 },
                                { min: 2160, max: 4319, value: 30 },
                                { min: 4320, max: 7199, value: 35 },
                                { min: 7200, max: Infinity, value: 40 },
                              ],
                              0
                            )}{" "}
                            %
                          </div>
                        </li>
                        {/* <li className="price-detail">
                          <div className="order-title">
                            To fulfil your annual requirement purchase :
                          </div>

                          <div className="order-amt fw-bolder">
                            {parseInt(
                              renderValueBasedOnRangeDiff(
                                calculateTotalAmount(),
                                [
                                  { min: 480, max: 719, caretvalue: 480 },
                                  { min: 720, max: 1199, caretvalue: 960 },
                                  { min: 1200, max: 2159, caretvalue: 1440 },
                                  { min: 2160, max: 4319, caretvalue: 2880 },
                                  { min: 4320, max: 7199, caretvalue: 5760 },
                                  {
                                    min: 7200,
                                    max: Infinity,
                                    caretvalue: 11520,
                                  },
                                ]
                              )
                            ) < 0
                              ? 0
                              : numberWithCommas(
                                  renderValueBasedOnRangeDiff(
                                    calculateTotalAmount(),
                                    [
                                      { min: 480, max: 719, caretvalue: 480 },
                                      { min: 720, max: 1199, caretvalue: 960 },
                                      {
                                        min: 1200,
                                        max: 2159,
                                        caretvalue: 1440,
                                      },
                                      {
                                        min: 2160,
                                        max: 4319,
                                        caretvalue: 2880,
                                      },
                                      {
                                        min: 4320,
                                        max: 7199,
                                        caretvalue: 5760,
                                      },
                                      {
                                        min: 7200,
                                        max: Infinity,
                                        caretvalue: 11520,
                                      },
                                    ]
                                  )
                                )}
                          </div>
                        </li> */}
                      </ul>
                      <Button
                        disabled={calculateTotalAmount() <= 479 || isLoading}
                        block
                        color="primary"
                        className="btn-next place-order mb-1"
                      >
                        Subscription Purchase
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Form>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <StripeElement>
        <PaymentWizard
          show={paymentPopup}
          setShow={setPaymentPopup}
          setCalculatorModel={setShow}
          module="pricing_calculator"
        />
      </StripeElement>
      <CPtoClipBoardModal setCopyModal={setCopyModal} CopyModal={CopyModal} />
    </>
  );
};

export default PricingCalculatorModel;
